import { createSlice } from "@reduxjs/toolkit"
import { generateRandomAlphaNumeric } from "../Utils/alphaNumeric"

const initialState = {
    images: [],
    fullScanS3Folder: ''
}

const fullScanSlice = createSlice({
    name: 'fullScan',
    initialState,
    reducers: {
        clearImages: () => {
            return initialState
        },
        addImages: (state, action) => {
            // Upsert by canonical step title. A stalled upload + "Rescan" can produce two
            // successful uploads for the same step; appending both inflated images.length
            // and fired the length-based completion gates with a step still missing
            // (uid JGGR47927082 submitted without upper_jaw). Newest response wins.
            const index = state.images.findIndex((img) => img.title === action.payload.title)
            if (index === -1) {
                state.images.push(action.payload)
            } else {
                state.images[index] = action.payload
            }
        },
        // Drop specific steps by title. Used when the backend rejects a submission because an
        // image it needed never arrived: the local entry exists (so the picker showed a tick and
        // isScanComplete passed) but carries no uploaded path. Removing it makes the picker tell
        // the truth again and re-opens that step for capture.
        removeImages: (state, action) => {
            const titles = action.payload
            state.images = state.images.filter((img) => !titles.includes(img.title))
        },
        createFullScanS3Folder: (state) => {
            const randomString = generateRandomAlphaNumeric(2);
            const timestamp = Date.now().toString();
            const randomString2 = generateRandomAlphaNumeric(1)
            state.fullScanS3Folder = randomString + timestamp + randomString2
        },
        clearFullScanfolder: (state) => {
            state.fullScanS3Folder = ''
        }
    }

})

export default fullScanSlice.reducer
export const { clearImages, addImages, removeImages, createFullScanS3Folder, clearFullScanfolder } = fullScanSlice.actions